import { ChangePassword, Login, LoginAuth } from '../bus/auth/types';
import { getLoginUrl, getLogoutUrl } from '../utils/auth-mode';
import $axios from '../utils/axios-instance';

export default class LoginApi {
  async getLogin(data: LoginAuth) {
    return await $axios
      .post<Login>(getLoginUrl(), data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getChangePassword(data: ChangePassword) {
    return await $axios
      .post('/v1/login/ChangePassword', data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }
  async logOut() {
    return await $axios
      .post(getLogoutUrl())
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async claims() {
    return await $axios
      .get<string[]>('/v1/Login/claims')
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }
}
